import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useFeaturesStore from '../store/cmsStore/featuresStore';
import Seo from '../components/Seo';


const Features: React.FC = () => {
  const { sections, fetchFeaturesContent } = useFeaturesStore();

  const location = useLocation();

useEffect(() => {

  if (location.hash) {
    const element = document.getElementById(location.hash.substring(1));
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }else{
    window.scrollTo(0, 0);
  }
}, [location]);

  useEffect(() => {
    fetchFeaturesContent();
  }, [fetchFeaturesContent]);

  return (
    <>
        <Seo
          title="SLAMMMM Features - Tools to Meet, Mingle & Marry"
          description="Explore SLAMMMM's features designed to help singles connect authentically, spark real conversations, and meet in person — no endless swiping. Sign up now!"
        />
    {sections.header_section && (
     <section className="hero_section_inner position-relative bg-light pt-4 ">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="hero_caption">
                        <h1 className="text-dark"><span className="text-primary">{sections.header_section.payload.field_1.value}</span> {sections.header_section.payload.field_2.value}
                        </h1>
                       
                    </div>
                </div>
                <div className="col-lg-6 pe-0">
                    <div className="hero_section_inner_img features_hero_inner_img" style={{ backgroundImage: `url(${sections.header_section.payload.field_3.value})`}}>

                    </div>
                </div>
            </div>
        </div>
    </section>
    )}
{sections.our_features_section_1 && ( 
    <section className="py-100 our_values_section">
        <div className="container">
            {sections.our_features_section_1 && ( 
            <div className="border-bottom pb-lg-5 pb-4">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <div className="section_title">
                            <p className="text-primary">{sections.our_features_section_1.payload.field_1.value}</p>
                            <h2 className="mb-0">{sections.our_features_section_1.payload.field_2.value}</h2>
                        </div>
                    </div>
                    <div className="col-lg-7 ps-lg-5">
                        <p className="font20 mb-0">{sections.our_features_section_1.payload.field_3.value}
                        </p>
                    </div>
                </div>
            </div>
            )}
            {sections.our_features_section_1 && ( 
            <div className="row g-4 mt-lg-4 mt-2" id="love_diamond">
                <div className="col-lg-5">
                    <div className="">
                        <img src={sections.our_features_section_1.payload.field_4.value} className="img-fluid rounded-4 shadow-sm" alt="" />
                    </div>
                </div>
                <div className="col-lg-6 offset-lg-1 ps-lg-0">
                    <div className="section_title mb-lg-4 mb-3">
                        <div className="d-flex align-items-center">
                            <div className="love_diamond_icon me-4">
                                <img alt="" className="img-fluid" src={sections.our_features_section_1.payload.field_5.value} />
                            </div>
                            <h2>{sections.our_features_section_1.payload.field_6.value}</h2>
                        </div>
                    </div>
                    <p className="font20 mb-lg-4 mb-3">{sections.our_features_section_1.payload.field_7.value}
                    </p>
                    <p className="font22 text-primary fw-bold mb-3">{sections.our_features_section_1.payload.field_8.value}</p>
                    <ul className="key_features_list">
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_1.payload.field_9.value }}>
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_1.payload.field_10.value }}>
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_1.payload.field_11.value }}>
                        </li>
                    </ul>
                    <Link to={sections.our_features_section_1.payload.field_12.link || '#'}><button className="btn btn-outline-primary mt-2">{sections.our_features_section_1.payload.field_12.value}</button></Link>

                </div>
            </div>
             )}

          {sections.our_features_section_2 && ( 
            <div className="row g-4 mt-lg-5 mt-4" id="genre_matching">
                <div className="col-lg-6 pe-lg-0 order-2 order-lg-1">
                    <div className="section_title mb-lg-4 mb-3">
                        <h2 className="mb-0">{sections.our_features_section_2.payload.field_1.value}</h2>
                    </div>
                    <p className="font20 mb-lg-4 mb-3">{sections.our_features_section_2.payload.field_2.value}</p>
                    <p className="font22 text-primary fw-bold mb-3">{sections.our_features_section_2.payload.field_3.value}</p>
                    <ul className="key_features_list">
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_2.payload.field_4.value}}>
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_2.payload.field_5.value}}>
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_2.payload.field_6.value}}>
                        </li>
                    </ul>
                    <Link to={sections.our_features_section_2.payload.field_7.link || '#'}><button className="btn btn-outline-primary mt-2">{sections.our_features_section_2.payload.field_7.value}</button></Link>

                </div>
                <div className="col-lg-5 offset-lg-1  order-1 order-lg-2">
                    <div className="">
                        <img src={sections.our_features_section_2.payload.field_8.value} className="img-fluid rounded-4 shadow-sm"
                            alt="" />
                    </div>
                </div>

            </div>
             )}
          {sections.our_features_section_3 && ( 
            <div className="row g-4 mt-lg-5 mt-4" id="send_likes">
                <div className="col-lg-5 ">
                    <div className="">
                        <img src={sections.our_features_section_3.payload.field_1.value} className="img-fluid rounded-4 shadow-sm" alt="" />
                    </div>
                </div>
                <div className="col-lg-6 offset-lg-1 ps-lg-0">
                    <div className="section_title mb-lg-4 mb-3">
                        <h2>{sections.our_features_section_3.payload.field_2.value}</h2>
                    </div>
                    <p className="font20 mb-lg-4 mb-3">{sections.our_features_section_3.payload.field_3.value}
                    </p>
                    <p className="font22 text-primary fw-bold mb-3">{sections.our_features_section_3.payload.field_4.value}</p>
                    <ul className="key_features_list">
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_3.payload.field_5.value}}>
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_3.payload.field_6.value}}>
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: sections.our_features_section_3.payload.field_7.value}}>
                        </li>
                    </ul>
                    <Link to={sections.our_features_section_3.payload.field_8.link || '#'}><button className="btn btn-outline-primary mt-2 dfg">{sections.our_features_section_3.payload.field_8.value}</button></Link>

                </div>
            </div>
             )}
        </div>
    </section>
  )}
  
    </>
  );
};

export default Features;
